export enum TemplateTypes {
  SCHEDULE,
  TEXT,
}
